// Export all tool renderers
export { generate_palette } from './generate_palette';
export { fetch_current_marketing_calendar_day } from './fetch_current_marketing_calendar_day';
export { fetch_room_mocks } from './fetch_room_mocks';
export { rememberAboutUser } from './rememberAboutUser';
export { query_marketing_knowledgebase } from './query_marketing_knowledgebase';
export { think } from './think';
export { remember_for_user } from './remember_for_user';
export { fetch_user_images } from './fetch_user_images';
export { fetch_image_details } from './fetch_image_details';
export { fetch_user_collections } from './fetch_user_collections';
export { fetch_sparks } from './fetch_sparks';
export { fetch_spark_instructions } from './fetch_spark_instructions';
export { execute_spark } from './execute_spark';
export { update_image_title } from './update_image_title';
export { generate_reel } from './generate_reel';
export { generate_carousel } from './generate_carousel';
export { generate_post } from './generate_post';
export { defaultRenderer } from './default';
export { upload_image } from './upload_image';
export { search_images } from './search_images';
export { search_web } from './search_web';
export { search_community_discussions } from './search_community_discussions';
export { check_copyright_scans } from './check_copyright_scans';

// Create the TOOL_RENDERERS object
import { generate_palette } from './generate_palette';
import { fetch_current_marketing_calendar_day } from './fetch_current_marketing_calendar_day';
import { fetch_room_mocks } from './fetch_room_mocks';
import { rememberAboutUser } from './rememberAboutUser';
import { query_marketing_knowledgebase } from './query_marketing_knowledgebase';
import { think } from './think';
import { remember_for_user } from './remember_for_user';
import { fetch_user_images } from './fetch_user_images';
import { fetch_image_details } from './fetch_image_details';
import { fetch_user_collections } from './fetch_user_collections';
import { fetch_sparks } from './fetch_sparks';
import { fetch_spark_instructions } from './fetch_spark_instructions';
import { execute_spark } from './execute_spark';
import { update_image_title } from './update_image_title';
import { generate_reel } from './generate_reel';
import { generate_carousel } from './generate_carousel';
import { generate_post } from './generate_post';
import { generate_marketing_package } from './generate_marketing_package';
import { defaultRenderer } from './default';
import { upload_image } from './upload_image';
import { read_about_arthelper } from './read_about_arthelper';
import { search_images } from './search_images';
import { search_web } from './search_web';
import { search_community_discussions } from './search_community_discussions';
import { check_copyright_scans } from './check_copyright_scans';

export const TOOL_RENDERERS: Record<string, any> = {
  upload_image,
  generate_palette,
  fetch_current_marketing_calendar_day,
  fetch_room_mocks,
  rememberAboutUser,
  query_marketing_knowledgebase,
  think,
  remember_for_user,
  fetch_user_images,
  fetch_image_details,
  fetch_user_collections,
  fetch_sparks,
  fetch_spark_instructions,
  execute_spark,
  update_image_title,
  generate_reel,
  generate_carousel,
  generate_post,
  generate_marketing_package,
  read_about_arthelper,
  search_images,
  search_web,
  search_community_discussions,
  check_copyright_scans,
  default: defaultRenderer,
};
